import { initServices } from './serviceConfig'

let _svc
let _that

export default {
  Init: async (that) => {
    _that = that

    _svc = await initServices()

    _svc.interceptors.response.use(
      response => response,
      error => {
        _that.ErrorMixin_HandleError(error)
      }
    )
  },
  GetDocument: (template) => {
    try {
      return _svc.put('Gembox/Result', template)
    } catch {
      return null
    }
  },
  GetVergelijkingspuntenDocument: (template) => {
    try {
      return _svc.put('Gembox/ListResult', template)
    } catch {
      return null
    }
  },
  AddExportToQueue: (template, format, type) => {
    try {
      return _svc.put('Gembox/AddExport', template, {
        params: {
          format: format,
          type: type
        }
      })
    } catch {
      var foutmelding = 'Kon export niet in wachtrij plaatsen.'
      return foutmelding
    }
  },
  GetExportsPaged: (sortBy, sortType, search, page = 1, pageSize = 10) => {
    try {
      var res = _svc.get('Gembox/GetAllExports', {
        params: {
          sortBy: sortBy === undefined || sortBy === null ? 'exportDatum' : sortBy,
          sortType: sortType === undefined || sortType === null ? 'desc' : sortType,
          search: search === undefined || search === null ? ' ' : search,
          page: page,
          pageSize: pageSize
        }
      })
      return res
    } catch {
      return null
    }
  },
  DeleteExport: (idExport) => {
    try {
      return _svc.delete('Gembox/Delete', {
        params: {
          idExport: idExport
        }
      })
    } catch {
      return null
    }
  },
  GetTemplatesPaged: (sortBy, sortType, search, page = 1, pageSize = 10) => {
    try {
      var res = _svc.get('Template/Paged', {
        params: {
          sortBy: sortBy === undefined || sortBy === null ? 'naam' : sortBy,
          sortType: sortType === undefined || sortType === null ? 'asc' : sortType,
          search: search === undefined || search === null ? ' ' : search,
          page: page,
          pageSize: pageSize
        }
      })
      return res
    } catch {
      return null
    }
  },
  Create: (template) => {
    try {
      return _svc.post('Template/Create', template)
    } catch (ex) {
      return null
    }
  },
  GetAll: (active = null) => {
    try {
      return _svc.get('Template/GetAll', {
        params: {
          active: active
        }
      })
    } catch {
      return null
    }
  },
  Update: (template) => {
    try {
      return _svc.put('Template/Update', template)
    } catch {
      return null
    }
  },
  Delete: (idTemplate) => {
    try {
      return _svc.delete('Template/Delete', {
        params: {
          idTemplate: idTemplate
        }
      })
    } catch {
      return null
    }
  }
}
